import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { Radii } from '~/types/ThemeTypes'

const { defaults } = themeColorSectionKeys

//https://chakra-ui.com/docs/components/switch/theming
export const switchStyleParts = ['container', 'thumb', 'track'] as const

const helpers = createMultiStyleConfigHelpers(switchStyleParts)
export const SwitchStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      userSelect: 'none',
    },
    track: {
      boxShadow: 'none !important',
      borderRadius: Radii._3xl,
      backgroundColor: defaults.Switch.Background.Default,
      userSelect: 'none',
      _checked: {
        outline: 'none',
        backgroundColor: defaults.Switch.Background.Toggled,
      },
      _focus: {
        outline: 'none !important',
        boxShadow: 'none !important',
      },
    },
    thumb: {
      backgroundColor: defaults.Switch.Thumb.Default,
      borderRadius: Radii.full,
    },
  },
})
